(function(){

  function showSuccess() {
    // const tl = gsap.timeline();
    const success = document.createElement("div");
    success.classList.add("cookie-confirmation");
    success.innerHTML = "Thanks, your preference has been saved";
    document.body.appendChild(success);

    // tl.to(success, {
    //   duration: 0.4,
    //   opacity: 1,
    //   delay: 0.2,
    // }).to(success, {
    //   delay: 2,
    //   y: 120,
    //   onComplete: () => {
    //     success.parentNode.removeChild(success);
    //   },
    // });
  };

  function pushToGtm(consents) {
    for (const [name, consent] of Object.entries(consents)) {
      if (consent === true) {
        let eventName = "klaro-" + name + "-accepted";
        dataLayer.push({ event: eventName });
        console.log('pushed', eventName);
      }
    }
  }

  function pushToShopify(consents) {
    // If a user has opted into tracking, inform Shopify.
    if (consents.tracking === true) {
      window.Shopify.customerPrivacy.setTrackingConsent(true);
    }
  }

  function klaroUpdate(manager, eventType, data) {
    // Event for when consents are saved.
    if (eventType === 'applyConsents') {
      showSuccess();
      pushToGtm(manager.consents);
      pushToShopify(manager.consents);
    }
  }

  window.onload = function() {
    try {
      var manager = window.klaro.getManager();
      manager.watch({update: klaroUpdate })
      if (manager.confirmed) {
        pushToGtm(manager.consents);
        pushToShopify(manager.consents);
      }
    }
    catch (error) {
      // Do nothing if Klaro can't be found/used.
    }
  };

})();
